/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetInflationProgramRequest
 */
export interface SetInflationProgramRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetInflationProgramRequest
     */
    inflation?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetInflationProgramRequest
     */
    gio?: boolean | null;
}

/**
 * Check if a given object implements the SetInflationProgramRequest interface.
 */
export function instanceOfSetInflationProgramRequest(value: object): value is SetInflationProgramRequest {
    return true;
}

export function SetInflationProgramRequestFromJSON(json: any): SetInflationProgramRequest {
    return SetInflationProgramRequestFromJSONTyped(json, false);
}

export function SetInflationProgramRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetInflationProgramRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'inflation': json['inflation'] == null ? undefined : json['inflation'],
        'gio': json['gio'] == null ? undefined : json['gio'],
    };
}

export function SetInflationProgramRequestToJSON(json: any): SetInflationProgramRequest {
    return SetInflationProgramRequestToJSONTyped(json, false);
}

export function SetInflationProgramRequestToJSONTyped(value?: SetInflationProgramRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inflation': value['inflation'],
        'gio': value['gio'],
    };
}

